import React, { useContext } from "react"
import { Container, Heading, Flex, Button } from "@chakra-ui/react"
import { Link as GatsbyLink, graphql, useStaticQuery } from "gatsby"
import { DrawerContext } from "../../../contexts"
import { Logo, Icon } from "../../"

import Desktop from "./Desktop"
import Mobile from "./Mobile"

export function Header() {
  const { onOpen } = useContext(DrawerContext)

  const { allProjects } = useStaticQuery(graphql`
    query {
      allProjects: allMdx(
        sort: { fields: [frontmatter___date], order: DESC }
        filter: {
          fileAbsolutePath: { regex: "/data/feed/" }
          frontmatter: { tag: { eq: "Project" } }
        }
      ) {
        nodes {
          fields {
            slug
          }
        }
      }
    }
  `)

  const menu = [
    { icon: "home", label: "Home", url: "/" },
    { icon: "info", label: "About", url: "/about" },
    { icon: "box", label: "Packages", url: "/#packages" },
    { icon: "drone", label: "Services & Examples", url: "/services" },
    { icon: "location", label: "Projects", url: allProjects.nodes },
    { icon: "book", label: "Blog", url: "/blog" },
    { icon: "email", label: "Contact", url: "/#contact", isPrimary: true },
  ]

  return (
    <>
      <Mobile menu={menu} />

      <Flex
        alignItems="center"
        position="fixed"
        bg="base.d200"
        height="50px"
        width="full"
        as="header"
        zIndex={3}
        left={0}
        top={0}
      >
        <Container py={0}>
          <Flex justifyContent="flex-end" alignItems="center">
            <Flex
              _hover={{ color: "white" }}
              alignItems="center"
              color="gray.300"
              as={GatsbyLink}
              target="_blank"
              mr="auto"
              to="/"
            >
              <Logo />
              <Heading as="h1" size="lg" fontWeight="medium" my={0} ml={3}>
                360 Dragonfly
              </Heading>
            </Flex>
            <Desktop menu={menu} />
            <Button
              display={{ base: "flex", lg: "none" }}
              aria-label="Open Menu"
              alignSelf="center"
              onClick={onOpen}
              size="sm"
              bg="none"
            >
              <Icon name="burger" boxSize={6} />
            </Button>
          </Flex>
        </Container>
      </Flex>
    </>
  )
}
